import React from "react";
import TopOfNav from "../../layouts/topOfNav/topOfNav.component";
import StickyNav from "../../layouts/stickyNav/stickyNav.component";
import DrawerNav from "../../components/drawer/drawer.component";
import NavBar from "../../layouts/navbar/navbar.component";
import Footer from "../../layouts/footer/footer.component";
import AgenciesLayout from "../../layouts/agencies/agencies.layout";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import agenciesHeader from "../../assets/image/ancHead.png";

const AgenciesPage = () => {
	const IMEIElement = window.location.href.split("/")[4];
	const IMEI = IMEIElement ? IMEIElement.split("?")[0] : "";
	if (IMEI) {
		window.location.replace(`/agency/${IMEI}`);
	}
	return (
		<div>
			<TopOfNav />
			<StickyNav />
			<DrawerNav />
			<NavBar />
			<SubHeaderComponent
				imageSrc={agenciesHeader}
				pageName="نمایندگان"
			/>
			<AgenciesLayout />
			<Footer />
		</div>
	);
};

export default AgenciesPage;
